Apt.fn.make('filters', {
	/**
	 * Initialize module
	 *
	 * @param {String} name
	 * @param {Object} options
	 * @returns {Object}
	 */
	init: function(name, options) {
		var priv = this.$private,
			filters = Apt.filters.get();

		options = $.extend({
			filters: true,
			limit: 10,
			paginate: true,
			query: {},
			model: {
				emptyTitle: 'Nothing Found',
				emptyMessage: 'Please try another search'
			}
		}, options);

		priv.name = name;
		priv.options = options;

		priv.options.query.filters = filters;

		Object.keys(filters).forEach(function(key) {
			$('[data-value="' + filters[key] + '"]').addClass('-is-selected');
		});

		if ($.screen.size() < 4) {
			$$('filterGroup').addClass('-is-collapsed');
		}

		if (options.filters) {
			priv.getFilterData();
			priv.bindFilterEvents();
		}

		priv.bindCategories();
		priv.initSort();

		priv.fetch({
			page: priv.getPage(),
			sort: $.routes.parse().query.sort
		});

		return this;
	},

	/**
	 * Destroy module
	 */
	_destruct: function() {
		$.events.reset('filter');
		$.events.reset('pagination');

		if ($.app.results) {
			$.app.results.$destroy();
		}

		if ($.app.pagination) {
			$.app.pagination.$destroy();
		}
	}
}, {
	/**
	 * Fetch data from API
	 *
	 * @param {Object} [params]
	 * @param {Boolean} [scroll=false]
	 * @param {String} [path]
	 */
	fetch: function(params, scroll, path) {
		var scope = this,
			$app = $$('filter'),
			fetchClass = '-is-fetching',
			init = ! scope.results;

		$app.addClass(fetchClass);

		if (scroll) {
			var top;

			if ($.screen.size() < 4) {
				var $sort = $$('sort');

				if ($sort.length) {
					top = $sort.offset().top;
				} else {
					top = $$('results').offset().top;
				}
			} else {
				top = $app.offset().top;
			}

			$.animate.tween($._body, {
				scrollTop: top - 40
			});
		}

		var query = $.extend(true, scope.options.query, params);

		$.fetch.request({
			url: scope.options.source,
			data: query,
			json: true,
			success: function(data) {
				scope.data = data.data;

				var model = $.extend({
					results: scope.data
				}, scope.options.model);

				if (scope.options.transform) {
					scope.data = scope.options.transform(scope.data);
				}

				if (init) {
					scope.$target = $('<div />');

					$(scope.options.target || 'ref:results')
						.empty()
						.append(scope.$target);

					scope.results = $.app.make('results', {
						model: model,
						target: scope.$target,
						view: scope.options.view
					});
				} else {
					scope.results.$set(model);
				}

				if (scope.options.success) {
					scope.data = scope.options.success(scope.data);
				}

				if (scope.options.paginate && data.meta) {
					scope.paginate(data.meta.pagination);
				}

				var title;

				if (! init) {
					if (data.meta && data.meta.title) {
						var $title = $('title');

						$('h1, ref:activeBreadcrumb').html(data.meta.title.replace('®', '<sup>®</sup>'));

						title = data.meta.title + ' - ' + $title.text()
							.split(' - ')
							.slice(-1)[0];
					}

					if (! path) {
						var filters = query.filters || {};

						path = Apt.filters.build(null, filters, query.page);

						if (query.sort) {
							path += '?sort=' + query.sort;
						}
					}

					$.history.go({
						action: false,
						force: true,
						path: path,
						run: false,
						scrollTop: false,
						title: title
					});
				}

				if (scope.options.fn) {
					scope.options.fn();
				}
			},
			complete: function() {
				$app.removeClass(fetchClass);
			}
		});
	},

	/**
	 * Initialize sorting options
	 */
	initSort: function() {
		var $sort = $$('sort');

		if (! $sort.length) {
			return;
		}

		var scope = this,
			activeClass = '-is-active',
			sort = $.routes.parse().query.sort || '';

		if (sort) {
			scope.options.query.sort = sort;

			$sort.filter('[data-value="' + sort + '"]')
				.addClass(activeClass);
		} else {
			$sort.first()
				.addClass(activeClass);
		}

		$sort.unbind()
			.on('click', function(e, el) {
				var $option = $(el);

				$option.addClass(activeClass)
					.siblings()
					.removeClass(activeClass);

				scope.fetch({
					sort: $option.data('value')
				}, true);
			}, {
				cancel: true,
				namespace: 'filter'
			});
	},

	/**
	 * Setup pagination
	 *
	 * @param {Object} data
	 */
	paginate: function(data) {
		var scope = this,
			model = $.extend({
				query: {},
				current: data.current_page
			}, data);

		if ($.app.pagination) {
			$.app.pagination.$set(model);
			return;
		}

		var $target = $('<div />');

		$$('results').append($target);

		scope.initHelpers();

		$.app.make('pagination', {
			model: model,
			target: $target,
			view: 'filters.pagination'
		});

		scope.bindPagination();
	},

	/**
	 * Get pagination index
	 *
	 * @param {String} [path]
	 * @returns {String}
	 */
	index: function(path) {
		return (path || $.routes.uri().path).replace(/\/p\d+$/, '');
	},

	/**
	 * Get current page number
	 *
	 * @returns {Number}
	 */
	getPage: function() {
		var uri = $.routes.uri();

		if (uri.segments.length > 1) {
			var last = uri.segments.slice(-1)[0];

			if (/p\d+$/.test(last)) {
				return last.slice(1);
			}
		}

		return 1;
	},

	/**
	 * Bind pagination link actions
	 */
	bindPagination: function() {
		var scope = this;

		$('[data-num]').on('click', function(e, el) {
			var num = $(el).data('num');

			scope.fetch({
				page: num
			}, true);

			$.app.pagination.$set('current_page', num);
		}, {
			cancel: true,
			delegate: 'ref:pagination',
			namespace: 'filter'
		});
	},

	/**
	 * Get filter data
	 */
	getFilterData: function() {
		var scope = this;

		if (scope.options.filters !== true) {
			scope.buildFilterData(scope.options.filters);
			return;
		}

		$.fetch.request({
			url: '/api/v1/catalog/' + $.get('category', 'products') + '/filters',
			json: true,
			success: function(data) {
				if (! data.groups || ! data.groups.length) {
					return;
				}

				scope.buildFilterData(data.groups);
			}
		});
	},

	/**
	 * Build filter data
	 *
	 * @param {Array} groups
	 */
	buildFilterData: function(groups) {
		var params = Apt.filters.get();

		groups.forEach(function(group) {
			group.active = typeof params[group.handle] !== 'undefined';

			group.options.forEach(function(option) {
				var disabled = false,
					selected = false;

				if (group.active) {
					disabled = params[group.handle] !== option.value;
					selected = ! disabled;
				}

				option.disabled = disabled;
				option.selected = selected;
			});

			if ($.screen.size() < 4) {
				group.collapsed = true;
			}
		});

		$$('filters').html($.view.render('filters.options', groups))
			.show();
	},

	/**
	 * Bind filter events
	 */
	bindFilterEvents: function() {
		var scope = this,
			selectedClass = '-is-selected';

		$$('filterHead').on('click', function(e, el) {
			$(el).parent()
				.toggleClass('-is-collapsed');
		}, {
			namespace: 'filter',
			delegate: 'ref:filter'
		});

		$$('filterOption').on('click', function(e, el) {
			$(el).toggleClass(selectedClass)
				.siblings()
				.removeClass(selectedClass);

			scope.filterItems();
		}, {
			namespace: 'filter',
			delegate: 'ref:filter'
		});

		$$('filterToggle').on('click', function() {
			scope.filterItems();
		}, {
			namespace: 'filter',
			delegate: 'ref:filter'
		});
	},

	/**
	 * Calculate selected filters
	 */
	filterItems: function() {
		var scope = this,
			filters = {};

		$$('filterGroup').each(function(el) {
			var $el = $(el),
				handle = $el.data('handle'),
				$option = $$('filterOption', $el).filter('.-is-selected'),
				value = null;

			if ($option.length) {
				value = $option.data('value');
			}

			if (value) {
				filters[handle] = value;
			} else {
				delete filters[handle];
			}
		});

		$$('filterToggle').each(function(el) {
			if (el.checked) {
				filters[el.name] = 'y';
			} else {
				delete filters[el.name];
			}
		});

		delete scope.options.query.page;

		scope.options.query.filters = filters;

		this.fetch(null, true);
	},

	/**
	 * Bind categories
	 */
	bindCategories: function() {
		var scope = this,
			$categories = $$('categories');

		if (! $categories.length) {
			return;
		}

		var $heading = $$('categoriesHeading');

		$heading.on('click', function() {
			$categories.toggleClass('-is-collapsed');
		}, {
			delegate: $categories,
			namespace: 'filter'
		});

		if ($categories.data('static')) {
			return;
		}

		var $links = $categories.find('a'),
			activeClass = '-is-active';

		$links.unbind();

		$('a').on('click', function(e, el) {
			var $el = $(el),
				id = $el.data('id');

			$links.removeClass(activeClass);
			$el.addClass(activeClass);

			$.set('category', id);

			delete scope.options.query.page;

			scope.options.query.filters = {};

			scope.options.query.params = {
				category: id
			};

			scope.getFilterData();

			scope.fetch(null, true, el.href);
		}, {
			cancel: true,
			delegate: $categories,
			namespace: 'filter'
		});
	},

	/**
	 * Init view helpers
	 */
	initHelpers: function() {
		var scope = this;

		$.view.addHelper('paginate', function(current) {
			if (this.val < 2) {
				return false;
			}

			var resp = {
					pages: []
				},
				total = this.val,
				uri = $.routes.uri(),
				base = scope.index(uri.path),
				min = Math.max(1, Math.min(current + (total - current) - 4, current - 2)),
				max = Math.min(total, Math.max(current - (current - 1) + 4, current + 2)),
				i = min,
				params = $.copy(uri.query),
				query = '';

			if (Object.keys(params).length) {
				query = '?' + $.serialize(params);
			}

			while (i <= max) {
				var page = {
					num: i,
					path: base + (i > 1 ? '/p' + i : '') + query
				};

				if (i === current) {
					page.current = true;
				}

				resp.pages.push(page);

				i++;
			}

			if (min > 1) {
				if (min > 2) {
					resp.leading = true;
				}

				resp.first = {
					num: 1,
					path: base + query
				};
			}

			if (total > max) {
				if (total > max + 1) {
					resp.trailing = true;
				}

				resp.last = {
					num: total,
					path: base + '/p' + total + query
				};
			}

			if (current > 1) {
				resp.prev = {
					num: current - 1,
					path: base + (current > 2 ? '/p' + (current - 1) : '') + query
				};
			}

			if (current < total) {
				resp.next = {
					num: current + 1,
					path: base + '/p' + (current + 1) + query
				};
			}

			return resp;
		});
	}
});
